module.exports = __webpack_public_path__ + "img/logo.4a4a7189.png";